module.exports = __webpack_public_path__ + "img/resume_thumbnail-1-600x450.ade8de68.jpg";